import styled from '@emotion/styled/macro'
import React from 'react'

export default function Footer() {
  return (
    <Wrapper
      role='complementary'
      aria-label='تبلیغات'
    >
      <Inner>
        <Text>
          <Logo>
            <svg
              width='18'
              height='18'
              viewBox='0 0 24 24'
              fill='none'
              stroke='currentColor'
              strokeWidth='2.2'
              aria-hidden='true'
            >
              <path d='M13 2L3 14h9l-1 8 10-12h-9l1-8z' />
            </svg>
            ناین کرفت
          </Logo>
          <Desc>سرور ماین‌کرفت و vps · هر دو با پینگ عالی داخل ایران · تحویل زیر ۶۰ ثانیه</Desc>
        </Text>
        <Cta
          href='https://9craft.ir/ref?code=radio'
          target='_blank'
          rel='noopener sponsored'
        >
          خرید سرور
          <svg
            width='12'
            height='12'
            viewBox='0 0 24 24'
            fill='none'
            stroke='currentColor'
            strokeWidth='2.5'
            aria-hidden='true'
          >
            <path d='M5 12h14M12 5l7 7-7 7' />
          </svg>
        </Cta>
      </Inner>
    </Wrapper>
  )
}

const Wrapper = styled('footer')(() => ({
  flexShrink: 0,
  position: 'sticky',
  bottom: 0,
  zIndex: 2,
  background: 'var(--black-player-700)',
  padding: '0.75rem 1.5rem',
}))

const Inner = styled('div')(() => ({
  display: 'flex',
  direction: 'rtl',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '1rem',
  maxWidth: '1400px',
  margin: '0 auto',
  padding: '0.75rem 1.25rem',
  borderRadius: 'var(--radius)',
  background: 'var(--black-player-500)',
  border: '1px solid var(--text-700)',
  '@media (width < 700px)': {
    flexDirection: 'column',
    alignItems: 'stretch',
    textAlign: 'center',
  },
}))

const Text = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '0.2rem',
  minWidth: 0,
}))

const Logo = styled('span')(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '0.4rem',
  color: 'var(--text-white)',
  fontFamily: 'var(--primary-bold)',
  fontSize: '0.9rem',
  svg: {
    color: 'var(--primary-500)',
  },
  '@media (width < 700px)': {
    justifyContent: 'center',
  },
}))

const Desc = styled('span')(() => ({
  color: 'var(--text-300)',
  fontSize: '0.75rem',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  '@media (width < 700px)': {
    display: 'none',
  },
}))

const Cta = styled('a')(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '0.35rem',
  flexShrink: 0,
  padding: '0.5rem 1rem',
  borderRadius: '4px',
  fontSize: '0.8rem',
  fontWeight: 700,
  color: 'var(--text-900)',
  background: 'var(--primary-500)',
  transition: 'var(--transition)',
  ':hover': {
    color: 'var(--text-white)',
    background: 'var(--primary-800)',
  },
  '@media (width < 700px)': {
    justifyContent: 'center',
  },
}))
